import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import firebase from "../firebase";
import { Compile } from "../api/compileSvc";
import CompileJS from "./compile-js";
import { UpdateViewStats } from "../api/dbSvc";
import CourseList from "./course-list";
import Content from "./content";
import PartnerContext from "./partner-context";

import {
  Header,
  RightSubHeader,
  LeftSubHeader,
  RightSubHeaderBottom
} from "./header";

import Editor from "./editor";
import "./home.css";
import "bootstrap/dist/css/bootstrap.css";
import { Bar } from "./loader";
import * as routes from "../constants/routes";

let editorRef = "";

const didLoad = () => {
  console.log("DidLoad");
};

const didMount = editor => {
  //console.log("DidMount", editor);
  editorRef = editor;
};

const Home = props => {
  const qp = JSON.parse(localStorage.getItem("qp"));
  //console.log("Home -> qp: ", JSON.stringify(qp));
  let py = "";
  // if (qp && typeof qp.program_id !== "undefined") {
  //   py = qp.program_id === "Python3" ? "Python" : qp.program_id;
  // }
  if (qp && typeof qp.program_id !== "undefined") {
    py = qp.program_id;
  }

  const [lang, setLanguage] = useState(py || "javascript");

  const [output, setOutput] = useState("Output rendered here");
  const [homeView, setHomeView] = useState("List");
  const [loading, setLoading] = useState(false);
  const [courseName, setCourseName] = useState("javascript");
  const [courses, setCourses] = useState([]);

  const [course, setCourse] = useState("react");
  const [theme, setTheme] = useState("vs-dark");
  const origin = useContext(PartnerContext);

  //console.log("Home.js -> origin: ", origin);

  const extension = {
    javascript: ".js",
    python: ".py",
    react: ".js",
    go: ".go",
    python3: ".py"
  };

  useEffect(() => {
    if (props.location.state) {
      //console.log("partner language: ", props.location.state.partnerLang);
      // const partnerLang =
      //   props.location.state.partnerLang === "Python3" ? "Python3" : "Python";
      // setLanguage(partnerLang);
      setLanguage(props.location.state.partnerLang || "python");
    }

    console.log("Home -> origin: ", origin);

    if (origin === "partner") {
      //update the view stats counter
      const db = firebase.firestore();
      const ref = db.doc(`users/${qp.user_id}`);

      UpdateViewStats(qp.user_id, qp.program_id).then(response => {
        console.log("home.js -> UpdateViewStats status", response.status);
      });

      // ref.get().then(doc => {
      //   if (doc.exists) {
      //     const viewStats = doc.data().viewStats;

      //     // viewStats[qp.program_id] += 1;
      //     viewStats[qp.program_id]
      //       ? (viewStats[qp.program_id] += 1)
      //       : (viewStats[qp.program_id] = 1);
      //     ref.set(
      //       {
      //         viewStats: viewStats
      //       },
      //       { merge: true }
      //     );
      //   } else {
      //     console.log("User not available");
      //   }
      // });
    }
  }, []);

  useEffect(() => {
    console.log("home -> useEffect -> lang: ", lang);
  }, [lang]);

  const setSelectedCourse = courseName => {
    if (courseName !== "Courses") {
      setCourseName(courseName);
    }

    if (courseName === "Create Course" && courses) {
      //props.history.push(routes.CREATE_COURSE);
      props.history.push({
        pathname: routes.CREATE_COURSE,
        state: { courses: courses }
      });
    }
  };

  const toggle = () => {
    setHomeView(homeView === "List" ? "Detail" : "List");
    setOutput("");
  };

  const setJSOutput = result => {
    if (result.type === "LOG") {
      setOutput(result.data.toString());
    }
  };

  const handleJSCode = () => {
    // const jscode = editorRef.getValue();
    // return jscode;
    let jscode = "";
    if (editorRef) {
      jscode = editorRef.getValue();
      return jscode;
    } else {
      return "";
    }
  };

  const handleThemeClick = theme => {
    setTheme(theme);
  };

  const handleCode = () => {
    setLoading(true);
    setOutput("Running code...");
    //const code = editorRef.getValue();
    let code = "";

    if (editorRef) {
      code = editorRef.getValue();
    } else {
      code = "";
    }
    Compile(code, lang).then(response => {
      //console.log("home.js -> ", JSON.stringify(response));
      // if (response.output) {
      //   setOutput(response.output);
      //   setLoading(false);
      //   console.log("home.js -> output ", output);
      // } else if (response.errors) {
      //   setOutput(response.errors);
      //   setLoading(false);
      //   console.log("home.js -> error ", output);
      // }
      if (response.output || response.output === "") {
        setOutput(response.output);
        setLoading(false);
        //console.log("home.js -> output ", output);
      } else {
        console.log("response.error: ", response.error);
        if (response.error) {
          setOutput(response.error);
          //console.log("home.js -> error ", output);
        }
        setOutput("Code didn't run - try after some time.");
        setLoading(false);
      }
    });
  };

  const handleValueChange = () => {};

  const handleSignOut = () => {
    const auth = firebase.auth();
    auth.signOut().then(
      () => {
        console.log("Signed out");
        localStorage.clear();
        props.history.push(routes.LOGIN);
        // props.history.push({
        //   pathname: routes.LOGIN,
        //   state: {
        //     originPropFromHome: origin
        //   }
        // });
      },
      error => console.log("home -> Error signing out", error)
    );
  };

  const getSelectedCourse = course => {
    setHomeView(homeView === "List" ? "Detail" : "List");
    setCourse(course);
    //const py = course.language === "Python3" ? "Python" : course.language;
    //setLanguage(py);
    setLanguage(course.language);
  };

  const getSelectedLang = lang => {
    // const py = lang === "Python3" ? "Python" : lang;
    // setLanguage(py);
    setLanguage(lang);
  };

  const getCourses = courses => {
    let tmpCourses = [];
    if (courses) {
      courses.map(doc => {
        //console.log(`${doc.id} => (${JSON.stringify(doc.data(), null, 2)}`);
        let tmp = {};
        tmp["id"] = doc.id;
        tmp["course"] = doc.data().course;
        tmp["courseID"] = doc.data().courseID;
        tmp["courseName"] = doc.data().courseName;
        tmp["level"] = doc.data().level;
        tmpCourses.push(tmp);
      });
      setCourses(tmpCourses);
    }
  };

  const leftContainer =
    homeView === "List" ? (
      <CourseList
        className="pt-1 ml-1 mr-1"
        getSelectedCourse={getSelectedCourse}
        getSelectedLang={getSelectedLang}
        courseName={courseName}
        getCourses={getCourses}
      />
    ) : (
      <Content className="pt-1 ml-1 mr-1" courseID={course.courseID} />
    );

  const codeContainer =
    lang.toLowerCase() === "javascript" ? (
      <CompileJS
        setJSOutput={setJSOutput}
        fileName={`main${extension[lang.toLowerCase()]}`}
        handleJSCode={handleJSCode}
        handleThemeClick={handleThemeClick}
        theme={theme}
      />
    ) : (
      <RightSubHeader
        fileName={`main${extension[lang.toLowerCase()]}`}
        handleCode={handleCode}
        handleThemeClick={handleThemeClick}
        theme={theme}
      />
    );

  return (
    <div className="app-container contianer-fluid">
      {origin === "home" ? (
        <Header
          // siteTitle={title}
          setSelectedCourse={setSelectedCourse}
          handleSignOut={handleSignOut}
        />
      ) : (
        ""
      )}

      <div className="row">
        {origin === "home" ? (
          <div className="col-sm-4 pr-0 instructions-container border-bottom">
            <LeftSubHeader
              courseTitle={course.courseName ? course.courseName : "Courses"}
              toggle={toggle}
              homeView={homeView}
            />
            {leftContainer}
          </div>
        ) : (
          ""
        )}
        <div
          id="code-editor"
          className={
            origin === "home"
              ? "pl-0 pr-2 col-sm-8 code-container"
              : "col-sm-12 code-container"
          }
        >
          {codeContainer}

          <Bar loading={loading} />
          <div className="editor-container border-left border-bottom rounded">
            <div className="editor">
              <Editor
                didLoad={didLoad}
                didMount={didMount}
                selectedLanguage={
                  lang.toLowerCase() === "python3" ? "python" : lang
                }
                selectedTheme={theme}
                //these two props are needed only for create-course; dummy here
                value={""}
                onValueChange={handleValueChange}
              />
            </div>
          </div>
          <RightSubHeaderBottom />
          <div
            className={
              theme === "vs-dark"
                ? "output-container-dark border-left border-bottom rounded"
                : "output-container border-left border-bottom rounded"
            }
          >
            <p style={{ whiteSpace: "pre-wrap" }}>{output}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

Home.propTypes = {
  // children: PropTypes.node.isRequired
};

export default withRouter(Home);
